import { TablesInsert } from "@/lib/supabase/supabase_types_override"
import { supabase } from "@/lib/supabase/supabaseClient"
import { prepareCrmForInsert } from "../../../lib/prepareCrmForInsert"

export const createCrm = async (data: TablesInsert<'crm'>) => {
    data = prepareCrmForInsert(data);

    return await supabase
        .from('crm')
        .insert(data)
        .throwOnError()
        .select()
        .maybeSingle()
        .then(res=>res.data)
}